<template>
  <v-app>
    <modal-agree></modal-agree>
    <v-app-bar app>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{restaurantName}}</v-toolbar-title>
      <v-spacer></v-spacer>


      <v-btn icon @click="resizeCanvasDown()">
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      <v-btn icon @click="resizeCanvasUp()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn icon @click="$router.push({name : 'restaurants'})">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      Сетка
      <v-checkbox
        v-model="grid"
        hide-details
      ></v-checkbox>
      <v-btn icon @click="toggleFullScreen">
        <v-icon>mdi-fullscreen</v-icon>
      </v-btn>
      <v-btn icon @click="save">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>

<!--      <v-btn icon>-->
<!--        Сетка    <v-switch v-model="grid"  hide-details value input-value="true"></v-switch>-->
<!--      </v-btn>-->


    </v-app-bar>
    <v-content>
      <v-container id='herss' class="flex-item-grow center-vertical-container" style="position: absolute;
    overflow: auto;
    height: 100%;
    width: 100%;" fluid>
        <div id="canvasSizer" style="height: 100%">
          <div class="innerCanvasContainer" style="height: 100%" id="innerCanvasContainer">
            <app-canvas v-if="restaurant"
                        :restaurantTitle="restaurantName"
                        :zones="zones"
                        :map="restaurantMap"
                        :tablesExisting="tables"
            >
            </app-canvas>
          </div>
        </div>
      </v-container>
    </v-content>

    <v-navigation-drawer
      style="z-index: 99999;"
      id="core-navigation-drawer"
      v-model="drawer"
      :dark="false"
      :expand-on-hover="expandOnHover"
      mobile-break-point="960"
      app
      width="320"
      z-index="1"
      v-bind="$attrs"
    >

      <v-tabs
        v-model="tabControl"
        centered
        slider-color="yellow"
      >
        <v-tab
          key="tables"
          href="#tab-tables"
        >
          Столы
        </v-tab>

      </v-tabs>

      <v-tabs-items v-model="tabControl">
        <v-tab-item
          key="tables"
          value="tab-tables"
        >
          <div class="pa-2">
            <v-btn color="#90A4AE" dark large block @click="addCircleTable()">Круглый стол</v-btn>
          </div>
          <div class="pa-2">
            <v-btn color="#90A4AE" dark large block @click="addSquareTable">Квадратный стол</v-btn>
          </div>
          <div class="pa-2">
            <v-btn color="#26A69A" dark large block @click="addWall()">Стена</v-btn>
          </div>
          <div class="pa-2">
            <v-btn color="#26A69A" dark large block @click="addText()">Текст</v-btn>
          </div>
          <div class="pa-2">
            <v-btn color="#26A69A" dark large block @click="addCircle()">Круг</v-btn>
          </div>
          <div class="pa-2">
            <v-btn color="#26A69A" dark large block @click="addEllipse()">Эллипс</v-btn>
          </div>
        </v-tab-item>




      </v-tabs-items>

      <template v-slot:append>
        <div class="text-center">
          <v-btn color="teal" dark large block @click="save()">Сохранить</v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-navigation-drawer
      style="z-index: 99999;"
      v-if="editor"
      id="core-navigation-draweder"
       v-bind="$attrs"
      right
      fixed
      permanent
      app
    >

      <v-divider class="mb-1"/>

      <v-list
        dense
        nav
      >
        <v-list-item>
          <v-list-item-avatar
            class="align-self-center"
            color="white"
            contain
          >
            <v-img
              src="https://demos.creative-tim.com/vuetify-material-dashboard/favicon.ico"
              max-height="30"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="display-1"
              v-text="'Настройка столов'"
            />
            <v-icon dark>mdi-pencil</v-icon>
          </v-list-item-content>


        </v-list-item>

        <v-divider class="mb-2"/>
        <v-list-item>

          <v-list-item-content class="display-1">
            <v-text-field type="text" v-model="tableNumber" label="Номер стола" hide-details="auto"></v-text-field>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isTable">
          <v-list-item-content class="display-1">
            <v-text-field type="number" v-model="countPerson" label="Кол-во персон" hide-details="auto"></v-text-field>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isTable">
          <v-list-item-content class="display-1">
            <v-select
              v-model="zoneId"
              :items="zones"
              item-text="title"
              item-value="id"
              label="Зона"
              persistent-hint
              single-line
            ></v-select>
          </v-list-item-content>
        </v-list-item>

        <v-list-item>
          <v-list-item-content class="display-1">
            <v-text-field type="number" v-model="angle" label="Угол" hide-details="auto"></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isDecoration">
          <v-list-item-content class="display-1">
            <v-text-field type="number" v-model="width" label="Ширина" hide-details="auto"></v-text-field>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isDecoration">
          <v-list-item-content class="display-1">
            <v-text-field type="number" v-model="height" label="высота" hide-details="auto"></v-text-field>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="isDecoration">
          <v-list-item-content class="display-1">
            <v-text-field type="text" v-model="color" label="Цвет заливки" hide-details="auto"></v-text-field>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="isDecoration">
          <v-list-item-content class="display-1">
            <v-color-picker v-model="generalColor" hide-inputs></v-color-picker>
          </v-list-item-content>
        </v-list-item>

      </v-list>

      <template v-slot:append>
        <div class="pa-2">
          <v-btn color="error" dark large block @click="deleteTable">Удалить</v-btn>
        </div>
      </template>
    </v-navigation-drawer>
    <editor></editor>
  </v-app>
</template>

<script>
  import AppCanvas from './Canvas'
  import Editor from './fragments/Editor'
  import ModalAgree from "../dashboard/component/ModalAgree"

  const MODE_TABLE = 'table';
  const MODE_DECORATION = 'decoration';

  export default {
    props: {
      restaurantId: {
        type: [Number, String],
      },
    },
    components: {
      Editor,
      AppCanvas,
      ModalAgree
    },
    mounted() {
      this.$store.dispatch('restaurantZones/loadZones', {
        restaurantId: this.restaurantId
      });
      this.$store.dispatch('restaurants/getRestaurant', {
        id: this.restaurantId
      }).then((data) => {
        this.restaurant = data.data
      })
      this.grid = true;
    },
    created() {
      bus.$on('editTable', (payload) => {
        this.countPerson = payload.countPerson;
        this.angle = payload.angle;
        this.tableNumber = payload.tableNumber;
        this.zoneId = payload.zoneId;
        this.id = payload.id;
        this.mode = MODE_TABLE;
      })
        .$on('showTableEditor', () => {
          this.editor = true
        })
        .$on('tableUnselected', () => {
            this.editor = false
          }
        )
      ;
    },
    data() {
      return {
        grid: false,
        zoneId: null,
        restaurant: null,
        color: null,
        generalColor: null,
        angle: 0,
        width: 0,
        height: 0,
        mode: MODE_TABLE,
        n: 50,
        tabControl: null,
        barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
        expandOnHover: false,
        drawer: false,
        editor: false,
        countPerson: 0,
        tableNumber: 0,
        id: 0,
      }
    },
    computed: {
      restaurantName() {
        try {
          return this.restaurant.title
        } catch (e) {
          return ''
        }
      },
      restaurantMap() {
        try {
          return this.restaurant.schema
        } catch (e) {
          return null
        }
      },
      tables() {
        try {
          return this.restaurant.tables
        } catch (e) {
          return null
        }
      },
      zones() {
        return this.$store.getters['restaurantZones/getZones']
      },
      getEventChangeName() {
        return this.isTable ? 'changeCountPerson' : 'changeInfoDecoration'
      },
      isTable() {
        return this.mode === MODE_TABLE
      },
      isDecoration() {
        return this.mode === MODE_DECORATION
      },
      countGuest() {
        if (this.countPerson < 1) {
          return 0
        }

        if (this.countPerson >= 500) {
          return 500;
        }
        return this.countPerson;
      }
    },
    watch: {
      grid() {
        bus.$emit('changeStatusGrid', this.grid)
      },
      generalColor() {
        this.color = this.generalColor.hexa
      },
      height() {
        this.emit()
      },
      width() {
        this.emit()
      },
      zoneId() {
        this.emit()
      },
      color() {
        this.emit()
      },
      angle() {
        this.emit()
      },
      countPerson() {
        this.emit()
      },
      tableNumber() {
        if (this.tableNumber) {
          this.emit()
        }
      }
    },

    methods: {
      resizeCanvasDown(){
        bus.$emit('resizeCanvasDown');
      },
      resizeCanvasUp(){
        bus.$emit('resizeCanvasUp');
      },
      save() {
        bus.$emit('saveMap', {
          restaurantId: this.restaurantId
        })
      },
      emit() {
        bus.$emit(this.getEventChangeName, {
          id: this.id,
          zoneId: this.zoneId,
          countPerson: this.countGuest,
          textValue: this.tableNumber,
          angle: this.angle,
          color: this.color,
          width: this.width,
          height: this.height
        })
      },
      addWall() {
        bus.$emit('addWall')
      },
      addText() {
        bus.$emit('addText')
      },
      addCircle() {
        bus.$emit('addCircle')
      },
      addEllipse() {
        bus.$emit('addEllipse')
      },
      addCircleTable() {
        bus.$emit('addCircleTable')
      },
      addSquareTable() {
        bus.$emit('addSquareTable')
      },
      deleteTable() {
        bus.$emit('deleteTable');
      },
      toggleFullScreen() {
        var elem = document.body;
        // ## The below if statement seems to work better ## if ((document.fullScreenElement && document.fullScreenElement !== null) || (document.msfullscreenElement && document.msfullscreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if ((document.fullScreenElement !== undefined && document.fullScreenElement === null) || (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) || (document.mozFullScreen !== undefined && !document.mozFullScreen) || (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)) {
          if (elem.requestFullScreen) {
            elem.requestFullScreen();
          } else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
          } else if (elem.webkitRequestFullScreen) {
            elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
          } else if (elem.msRequestFullscreen) {
            elem.msRequestFullscreen();
          }
        } else {
          if (document.cancelFullScreen) {
            document.cancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      }
    }
  }
</script>

<style>
  /* полоса прокрутки (скроллбар) */
  ::-webkit-scrollbar {
    width: 8px; /* ширина для вертикального скролла */
    height: 8px; /* высота для горизонтального скролла */
    background-color: #143861;
  }

  /* ползунок скроллбара */
  ::-webkit-scrollbar-thumb {
    background-color: #843465;
    border-radius: 9em;
    box-shadow: inset 1px 1px 10px #f3faf7;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #253861;
  }

  /* Стрелки */

  ::-webkit-scrollbar-button:vertical:start:decrement {
    background: linear-gradient(120deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
    linear-gradient(240deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
    linear-gradient(0deg, #02141a 30%, rgba(0, 0, 0, 0) 31%);
    background-color: #f6f8f4;
  }

  ::-webkit-scrollbar-button:vertical:end:increment {
    background:
      linear-gradient(300deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
      linear-gradient(60deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
      linear-gradient(180deg, #02141a 30%, rgba(0, 0, 0, 0) 31%);
    background-color: #f6f8f4;
  }

  ::-webkit-scrollbar-button:horizontal:start:decrement {
    background:
      linear-gradient(30deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
      linear-gradient(150deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
      linear-gradient(270deg, #02141a 30%, rgba(0, 0, 0, 0) 31%);
    background-color: #f6f8f4;
  }

  ::-webkit-scrollbar-button:horizontal:end:increment {
    background:
      linear-gradient(210deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
      linear-gradient(330deg, #02141a 40%, rgba(0, 0, 0, 0) 41%),
      linear-gradient(90deg, #02141a 30%, rgba(0, 0, 0, 0) 31%);
    background-color: #f6f8f4;
  }
  .canvas-container {
    border: 2px solid #ddd;
    background-size: 50px;
    background-repeat: repeat;
  }
</style>
